import { Menu, Transition } from "@headlessui/react";
import { UserIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { useAuth } from "../contexts/AuthContext";
import { DialogEnum, useDialog } from "../contexts/DialogContext";
import { RoutePaths } from "../routes";

export default function AuthBar() {
  const dialog = useDialog();
  const { signOut, account } = useAuth();

  return (
    <div className="h-10 bg-[#F2F5FA] fixed z-[90] w-full flex items-center justify-end pr-[72px] gap-5">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex justify-center w-full text-sm text-primary-blue outline-none">
            Help
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute w-40 p-2 right-0 mt-4 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <a
                    href={RoutePaths.INSTRUCTIONS}
                    className={`${
                      active
                        ? "bg-primary-blue text-white"
                        : "text-primary-blue"
                    } group flex rounded-md items-center w-full px-2 py-2 text-md`}
                  >
                    Instructions
                  </a>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <a
                    href={RoutePaths.CONTACT_US}
                    className={`${
                      active
                        ? "bg-primary-blue text-white"
                        : "text-primary-blue"
                    } group flex rounded-md items-center w-full px-2 py-2 text-md`}
                  >
                    Contact Us
                  </a>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
      <div className="h-5 border-l border-gray-300" />
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="flex justify-center w-full text-sm text-primary-blue outline-none grow">
            <UserIcon className="w-5 h-5 mr-2" />
            Hi, {account?.firstName}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute w-48 p-2 right-0 mt-4 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <a
                    href={RoutePaths.ACCOUNT_EDIT}
                    className={`${
                      active
                        ? "bg-primary-blue text-white"
                        : "text-primary-blue"
                    } group flex rounded-md items-center w-full px-2 py-2 text-md`}
                  >
                    My Account
                  </a>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => dialog.push(DialogEnum.CHANGE_PASSWORD)}
                    className={`${
                      active
                        ? "bg-primary-blue text-white"
                        : "text-primary-blue"
                    } group flex rounded-md items-center w-full px-2 py-2 text-md`}
                  >
                    Change Password
                  </button>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={signOut}
                    className={`${
                      active
                        ? "bg-primary-blue text-white"
                        : "text-primary-blue"
                    } group flex rounded-md items-center w-full px-2 py-2 text-md`}
                  >
                    Log Out
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
